module.exports = __webpack_public_path__ + "img/swisscom-logo.62df8fa5.png";